import type { DealForecast } from '@openx/types/dealForecasting';

import { TopMarketRequestsType } from '../constants';
import type { TopMarketRequestsData } from '../types';

export const mapTopMarketRequestsEntries = (
  type: TopMarketRequestsType,
  forecast?: DealForecast
): TopMarketRequestsData[] => {
  const key = type === TopMarketRequestsType.DOMAINS ? 'top_domains' : 'top_bundles';
  const firstFraction = forecast?.[key]?.[0]?.fraction;

  if (!forecast || !firstFraction) {
    return [];
  }

  const copiedForecast = structuredClone(forecast);
  const sortedEntries = copiedForecast[key].slice().sort((a, b) => b.fraction - a.fraction);
  const totalFraction = sortedEntries.reduce((sum, item) => sum + item.fraction, 0);

  return sortedEntries.map(item => {
    const { fraction, bundle, domain } = item;
    const entry = domain || bundle;

    const progress = Math.round((fraction / totalFraction) * 100);
    const marketRequests = `${parseFloat((fraction * 100).toFixed(4))}%`;

    return {
      entry,
      marketRequests,
      progress,
    };
  });
};
